<template>
	<div class="account__section autorefresh display">
		<div @click="$store.commit('settings/changeTheme')">
			<h3
				class="account__section__title"
				style="display: flex; flex-direction: column"
			>
				{{ $t("overlay-menu.display") }}
			</h3>
			<p class="account__section__desc">
				{{ $t("overlay-menu.switch-theme") }}
			</p>
		</div>
		<toggle-button />
	</div>
</template>

<script>
import ToggleButton from "../../Shared/ThemeToggleButton.vue";

export default {
	components: {
		ToggleButton,
	},
};
</script>
